import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { Institute } from '../../../models/institute/randomInstituteResponse';
import { EssayAnswerResponse } from '../../../models/essay-pilot/essayAnswerResponse';
import { Store } from '@ngxs/store';
import { EssayPilotService } from '../../../services/essay-pilot/essay-pilot.service';
import { pilotType } from '../../../models/essay-pilot/essayQuestionRequest';
import { SetMyAddedInstitute } from '../../../states/myInstitutes/my-institute-actions';
import { MyInstituteService } from '../../../services/institute/myinstitute/my-institute.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PastEssaySubmissionResponse } from '../../../models/essay-pilot/pastEssaySubmissionResponse';
import { UserStateModel } from '../../../states/user/user-state-model';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { EssayAnswerDialogComponent } from "./essay-answer-dialog/essay-answer-dialog.component";
import { essayOptions } from '../../../student-portal/essay-pilot/essay-pilot.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PastEssayQuestionResponse } from '../../../models/essay-pilot/pastEssayQuestionResponse';
import { AdditionalInformation } from '../../../models/enums/additionalInformation';
import { AdditionalInformationRightSectionComponent } from "../additional-information-right-section/additional-information-right-section.component";
import { ReviewSubmissionComponent } from "../../review-submission/review-submission.component";
import { AuthService } from '../../../services/account/auth.service';
import { UserResponse } from '../../../models/account/userResponse';
enum selectedTab {
  essaypilot,
  additionalInfo
}

@Component({
  selector: 'app-essay-pilot-section',
  standalone: true,
  imports: [ButtonModule, DropdownModule, InputTextModule, CheckboxModule, CommonModule, DialogModule, ProgressSpinnerModule, AdditionalInformationRightSectionComponent, ReviewSubmissionComponent],
  templateUrl: './essay-pilot-section.component.html',
  styleUrl: './essay-pilot-section.component.scss'
})
export class EssayPilotSectionComponent implements OnInit {
  studentId: string = '';
  myInstitutes: Institute[] = [];
  essays: EssayAnswerResponse[] = [];
  pilotType = pilotType;
  currentPilotType: pilotType = pilotType.common;
  isLoading: boolean = false;
  instituteId: string | undefined;
  initialContent: string = '';
  recentQuestions: essayOptions[] = [];

  infotype = AdditionalInformation;
  selectedTab = selectedTab;
  currentSelectedTab = selectedTab.essaypilot;


  constructor(private store: Store,
    private essayPilotService: EssayPilotService,
    private myInstituteService: MyInstituteService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private authService: AuthService
  ) {

  }
  ngOnInit(): void {
    this.studentId = this.route.snapshot.paramMap.get('id') || '';
    this.getStudentInfo();
    this.getMyInstitutes();
  }

  getStudentInfo() {
    this.authService.getUserByid(this.studentId).subscribe({
      next: (response) => {
        this.student = response;
        this.getPastQuestionSubmissions();
      },
      error: (err) => {
        console.warn("Error Loading Student:", err)
    },  
    });
  }

  visible: boolean = false;
  isLoadingPastSubmssions: boolean = false;
  pastSubmissions: PastEssaySubmissionResponse[] = [];
  selectedSubmission: PastEssaySubmissionResponse | null = null;
  currentSelectedIndex: number = 0;
  user: UserStateModel | undefined;
  student!: UserResponse;

  showDialog() {
    this.visible = true;
  }
  closeDialog(){
    this.visible = false;
  }

  // private updateSelectedSubmission(index: number): void {
  //   if(this.pastSubmissions && this.pastSubmissions.length > 0 && index >= 0 && index < this.pastSubmissions.length){
  //     this.selectedSubmission = this.pastSubmissions[index];
  //     this.currentSelectedIndex = index;
  //   }else{
  //     this.selectedSubmission = null;
  //     this.currentSelectedIndex = 0;
  //   }
  //   // this.selectedSubmission = this.submissions.length > 0 ? this.submissions[0] : null;
  // }

  getRecentCommonSubmissions(essay: essayOptions) {
    this.isLoadingPastSubmssions = true;
    this.essayPilotService.getPastSubmissions({
      question: essay.title ?? '',
      studentId: this.studentId,
    }).subscribe({
      next: (submissions) => {
        this.isLoadingPastSubmssions = false;
        this.pastSubmissions = submissions.result ?? [];
        if (submissions.result.length > 0) {
          this.showDialog();
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
        }
      },
      error: (error) => {
        this.isLoadingPastSubmssions = false;
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
      }
    });
  }

  getRecentSubmissions(essay: essayOptions, instituteId?: string) {
    this.isLoadingPastSubmssions = true;
    this.essayPilotService.getPastSubmissions({
      question: essay.title ?? '',
      studentId: this.studentId,
      instituteId: instituteId ?? this.instituteId ?? ''
    }).subscribe({
      next: (submissions) => {
        this.isLoadingPastSubmssions = false;
        this.pastSubmissions = submissions.result ?? [];
        if (submissions.result.length > 0) {
          this.showDialog();
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
        }
      },
      error: (error) => {
        this.isLoadingPastSubmssions = false;
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
      }
    });
  }



  getPastQuestionSubmissions(instituetId?: string) {
    this.currentSelectedTab = selectedTab.essaypilot;
    this.recentQuestions = [];
    this.isLoading = true;
    this.instituteId = instituetId;
    this.essayPilotService.getPastEssayQuestions({
      studentId: this.studentId,
      instituteId: instituetId ?? '',
      courseLevel: this.student.degreePreference!,
      courseName: this.student.intendedMajor ?? ''
    }).subscribe({
      next: (response: { result: PastEssayQuestionResponse[] }) => {
        const recentQuestions = response.result.map((essay: PastEssayQuestionResponse) => ({
          title: essay.question ?? '',
          name: essay.question ?? '',
          wordlimit: essay.requestedAnswerWordLimitByAdmin
        }));
        this.recentQuestions = recentQuestions;
        this.isLoading = false;
        if (instituetId) {
          this.currentPilotType = pilotType.specific;
        } else {
          this.currentPilotType = pilotType.common;
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.warn(`Error while loading questions: ${error}`);
      }

    })
  }

  getMyInstitutes() {
    
    console.log('Fetching institutes for student ID:', this.studentId);
    this.myInstituteService.getMyInstitutesByid(this.studentId).subscribe({
      next: (response: Institute[]) => {
        
        this.store.dispatch(new SetMyAddedInstitute({ items: response }));
        this.myInstitutes = response;
      },
      error: (error) => {
        console.log('Error fetching institutes');
      },
      complete: () => {
        console.log('Institute fetching completed');
      }
    });
  }

  openAdditionalInfo() {
    this.currentSelectedTab = selectedTab.additionalInfo;
  }

  // getRecentSubmissions(essay: EssayAnswerResponse) {
  //   this.isLoadingPastSubmssions = true;
  //   this.essayPilotService.getPastSubmissions({
  //     question: essay.question ?? '',
  //     instituteId: this.instituteId ?? '',
  //     studentId: this.studentId,
  //   }).subscribe({
  //     next: (submissions) => {
  //       this.isLoadingPastSubmssions = false;
  //       this.pastSubmissions = submissions.result ?? [];
  //       if (submissions.result.length > 0) {
  //         this.showDialog();
  //       }
  //       else {
  //         this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
  //       }
  //     },
  //     error: (error) => {
  //       this.isLoadingPastSubmssions = false;
  //       this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
  //     },
  //   });
  // }

  // loadCommonEssay() {
  //   //reset recommned text
  //   this.initialContent = '';
  //   //ended
  //   this.isLoading = true;
  //   this.commonQuestions = [];
  //   this.essayPilotService.getCommonEssayQuestions().subscribe({//change this to use PastEssayQuestionEndpoint
  //     next: (response) => {
  //       const newEssays = response.result.map(essay => ({
  //         title: essay.question ?? '',  // Fallback to empty string if question is null
  //         name: essay.question ?? ''    // Fallback to empty string if question is null
  //       }));
  //       this.commonQuestions = newEssays;
  //       this.isLoading = false;
  //       this.currentPilotType = pilotType.common;
  //     },
  //     error: (error) => {
  //       this.isLoading = false;
  //       console.warn(`Error while loading common questions: ${error}`);
  //     }
  //   });
  // }



  //   loadInstituteEssays(instituteId: string) {
  //       this.instituteId = instituteId;
  //       this.isLoading = true;
  //       this.essays = [];
  //       this.essayPilotService.getInstituteQuestions(instituteId).subscribe({
  //         next: (response) => {
  //           if (!response) {
  //             this.isLoading = false;
  //             this.currentPilotType = pilotType.specific; // After all requests complete
  //           }
  //           if (response) {
  //             const questions = [
  //               response.question1,
  //               response.question2,
  //               response.question3,
  //               response.question4,
  //               response.question5,
  //             ].filter(Boolean); // Filter out any undefined or null questions.
  //             this.isLoading = false;

  //             // Sequentially process questions
  //             of(...questions)
  //               .pipe(
  //                 concatMap((question) =>
  //                   this.essayPilotService
  //                     .getStudentEssayAnswer({ question: question ?? '', InstituteId: instituteId })
  //                     .pipe(
  //                       map((result) =>
  //                         result ? result : { question } // If no result, add default question.
  //                       ),
  //                       catchError((error) => {
  //                         // Return a default value with the question.
  //                         return of({ question });
  //                       })
  //                     )
  //                 ),
  //                 finalize(() => {
  //                   this.isLoading = false;
  //                   this.currentPilotType = pilotType.specific; // After all requests complete
  //                 })
  //               )
  //               .subscribe({
  //                 next: (essay) => {
  //                   this.essays.push(essay); // Push each essay sequentially
  //                 },
  //               });
  //           }
  //         },
  //         error: (error) => {
  //           this.isLoading = false;
  //           console.warn(`Error while loading institute questions: ${error}`);
  //         },
  //       });
  //     }

}
